import { useState, useEffect, useCallback } from 'react';
import { parseValidJSON } from './parseValidJSON';

const STORAGE_KEY = 'productComparisonListV2';

export const useProductComparison = () => {
  const [comparisonList, setComparisonList] = useState([]);

  useEffect(() => {
    const savedList = parseValidJSON(localStorage.getItem(STORAGE_KEY)) || [];
    setComparisonList(savedList);
  }, []);

  const addToComparison = (product) => {
    const { id, name, price, image } = product;
    if (!id) {
      return false;
    }
    const existingProduct = comparisonList.find((p) => p.id === id);
    if (existingProduct) {
      return false;
    }

    const _comparisonList = [...comparisonList, { id, name, price, image }];
    setComparisonList(_comparisonList);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(_comparisonList));
    return true;
  };

  const removeFromComparison = (productId) => {
    const _comparisonList = comparisonList.filter((p) => p.id !== productId);
    setComparisonList(_comparisonList);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(_comparisonList));
  };

  const isInComparison = useCallback(
    (productId) => {
      return comparisonList.some((p) => p.id === productId);
    },
    [comparisonList]
  );

  const clearAllComparisons = () => {
    setComparisonList([]);
    localStorage.removeItem(STORAGE_KEY);
  };

  return {
    comparisonList,
    addToComparison,
    removeFromComparison,
    isInComparison,
    clearAllComparisons,
  };
};

export default useProductComparison;
